/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    CUSTOMERS_title: "Clients",
    CUSTOMERS_create: "Créer un client",
    CUSTOMERS_edit: "Modifier le client",
    CUSTOMERS_fieldEmail: "Email du compte",
    CUSTOMERS_fieldBillingEmail: "Email de facturation",
    CUSTOMERS_fieldPhone: "Téléphone",
    CUSTOMERS_fieldName: "Nom du client",
    CUSTOMERS_fieldStreet: "Rue",
    CUSTOMERS_fieldCity: "Ville",
    CUSTOMERS_fieldPostalCode: "Code postal",
    CUSTOMERS_fieldCompany: "Société",
    CUSTOMERS_fieldNote: "Description",
    CUSTOMERS_fieldDescription: "Description",
    CUSTOMERS_fieldCountry: "Pays",
    CUSTOMERS_fieldVAT: "Numéro de TVA",
    CUSTOMERS_fieldIsStaff: "Staff",
    CUSTOMERS_confirmCreate: "Créer le client",
    CUSTOMERS_confirmEdit: "Modifier le client",
    CUSTOMERS_columnEmail: "Email du compte",
    CUSTOMERS_columnName: "Nom du contact",
    CUSTOMERS_columnAddress: "Adresse",
    CUSTOMERS_columnCountry: "Pays",
    CUSTOMERS_columnCompany: "Société",
    CUSTOMERS_columnState: "Etat",
    CUSTOMERS_columnCreated: "Créé le",
    GLOBAL_filterCustomerName: "Nom du contact",
    GLOBAL_filterCustomerPlaceholder: "Filtrer par nom du contact",
    CUSTOMERS_filterCompany: "Société",
    CUSTOMERS_filterCompanyPlaceholder: "Filtrer par société",
    CUSTOMERS_filterEmail: "E-mail",
    CUSTOMERS_filterEmailPlaceholder: "Filtrer",
    CUSTOMERS_filterAddress: "Adresse",
    CUSTOMERS_filterSearch: "Recherche",
    CUSTOMERS_filterSearchPlaceholder: "Société, contact, e-mail, téléphone, adresse",
    CUSTOMERS_filterPhone: "Téléphone",
    CUSTOMERS_filterPhonePlaceholder: "Numéro de téléphone",
    CUSTOMERS_filterAddressPlaceholder: "Filtrer par adresse",

    CUSTOMER_Details: "Détails client",
    CUSTOMER_accountInformation: "Informations sur le compte",
    CUSTOMER_invoiceInformation: "Informations de facturation",
    CUSTOMER_Description: "Description",
    CUSTOMER_addDescription: "Description",
    CUSTOMER_fieldPlaceholderVAT: "Numéro de VAT",
    CUSTOMER_fieldPlaceholderEmail: "Email du compte",
    CUSTOMER_fieldPlaceholderBillingEmail: "Adresse email de facturation",
    CUSTOMER_fieldPlaceholderName: "Nom du client",
    CUSTOMER_fieldPlaceholderAddress: "Adresse",
    CUSTOMER_fieldPlaceholderCompany: "Société",
    CUSTOMER_fieldPlaceholderNote: "Description",
    CUSTOMERS_fieldInvoicePrefix: "Préfixe de la facture",

    CUSTOMERS_createSuccessTitle: "Notification",
    CUSTOMERS_createSuccessMessage: "Nouveau client a été créé avec succés",
    CUSTOMERS_deleteConfirm: "Êtes-vous certain de vouloir supprimer ce" +
        " client ? | Êtes-vous certain de vouloir supprimer ces clients ?",
    CUSTOMER_deleteConfirm: "Êtes-vous certain de vouloir supprimer ce client ?",
    CUSTOMERS_cannotDelete: "Certains des clients sélectionnés ne peuvent pas être supprimés",
    CUSTOMERS_label: "Client",
    CUSTOMERS_plural_label: "Clients",
    CUSTOMERS_splashScreenTitle: "Créez votre premier client",
    CUSTOMERS_splashScreenDescription: "Un client de type personne ex. Madame Pauline GERMAIN",

    CUSTOMERS_formChanged: "Pas de changements | Vous avez modifié 1 champ du client | \
    Vous avez modifié {count} champs du client",
    CUSTOMERS_updated: "Client mis à jour",

    CUSTOMERS_endTrial: "Mettre fin à la période d'essai",
    CUSTOMERS_endTrialConfirm:
        "Voulez-vous vraiment mettre fin à la période d'essai pour ce client ? | \
        Voulez-vous vraiment mettre fin à la période d'essai pour ces clients  ?",
    CUSTOMER_endTrial: "La période d'essai est terminée avec succès",

    CUSTOMERS_actionSubscriptions: "Abonnements",
    CUSTOMERS_actionGroupUsers: "Voir les utilisateurs",
    Customer_taxIdInvalid: "Numéro de VAT non valide",

    CUSTOMERS_invoicesTitle: "Factures",
    CUSTOMERS_invoicesEmpty: "Aucune facture",
    CUSTOMERS_invoiceRejected: "REJETÉE",
    CUSTOMERS_paymentsTitle: "Paiements",
    CUSTOMERS_paymentsEmpty: "Aucun paiement",
    CUSTOMERS_paymentMethodValidity: "Valide jusqu'en {0}",
    CUSTOMERS_paymentMandateDownload: "Télécharger le mandat SEPA",
    CUSTOMERS_subscriptionsTitle: "Abonnement",
    CUSTOMERS_quotasTitle: "Quotas",
    CUSTOMERS_quotasEmpty: "Aucun abonnement : pas de quotas à afficher.",
    CUSTOMERS_subscriptionsEmpty: "Aucun abonnement",

    CUSTOMERS_usersTitle: "Utilisateurs",
    CUSTOMERS_userAccountOwner: "Propriétaire du compte",
    CUSTOMERS_usersEmpty: "Aucun utilisateur",
    CUSTOMERS_userColumnName: "Nom",
    CUSTOMERS_userColumnEmail: "E-mail",
    CUSTOMERS_userColumnPhone: "Téléphone",
    CUSTOMERS_userColumnStatus: "Statut",
    CUSTOMERS_userColumnCreated: "Créé le",
    CUSTOMERS_userColumnLastActivity: "Dernière connexion",
    CUSTOMERS_userColumnGroup: "Groupe",
    CUSTOMERS_userColumnCompany: "Société",
    CUSTOMERS_userColumnOwner: "Propriétaire",
    CUSTOMERS_userStatusActive: "Actif",
    CUSTOMERS_userStatusProcessing: "En attente d'approbation",
    CUSTOMERS_userStatusInactive: "Inactif",
    CUSTOMERS_userFilterAll: "Tous les statuts",
    CUSTOMERS_userSearchPlaceholder: "Rechercher un utilisateur"
};
